function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userAssessInfo, userAssessMark, userAssessTarget, userAssessSelfSaveApi, userSuperiorEvalSaveApi, userExamineEvalSaveApi, userAssessEditApi } from '@/api/user';
export default {
  name: 'Execution',
  components: {
    selectTarget: function selectTarget() {
      return import('@/components/form-common/dialog-target');
    },
    dialogForm: function dialogForm() {
      return import('../components/index');
    },
    setTemplate: function setTemplate() {
      return import('./setTemplate');
    }
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    strType: {
      type: String,
      default: ''
    },
    processIndex: {
      type: Number,
      default: 0
    },
    reply: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShow: {
      type: Number | Boolean,
      default: false
    },
    appeal: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    marks: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableData: [],
      commentList: [],
      type: 0,
      is_draft: 0,
      mark: '',
      assessInfo: [],
      testAccess: false,
      checkAccess: false,
      verifyAccess: false,
      onlyMark: '',
      dialogVisible: false,
      from: {
        name: '',
        ratio: 100
      },
      max: JSON.parse(localStorage.getItem('enterprise')).maxScore,
      message1: '驳回申诉',
      message2: '绩效申诉',
      message3: '请输入驳回理由',
      message4: '请输入申诉理由',
      rolesConfig: [],
      onlyShow: '',
      formBoxConfig: {},
      spaceIds: [],
      targetIds: [],
      testShow: true,
      checkShow: true,
      loading: false,
      templateLoading: false,
      setTemplate: {
        success: 0
      },
      total: 0,
      userInfo: this.$store.state.user.userInfo,
      enterprise: this.$store.state.user.enterprise
    };
  },
  computed: {
    dimensionMax: function dimensionMax() {
      var max = 100;
      if (this.assessInfo.types === 1) {
        max = Number(this.assessInfo.total);
      }
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          max -= value.ratio;
        });
      }
      return max;
    },
    text: function text() {
      return function (value) {
        if (value == '' || value == 0) {
          return '100%';
        } else {
          return String(value).length * 13 + 10 + 'px';
        }
      };
    }
  },
  watch: {
    reply: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        // 判断考核人是否有评论
        if (this.reply.length > 0) {
          this.reply.forEach(function (value) {
            if (value.types === -1) {
              _this.testShow = false;
            } else if (value.types === 0) {
              _this.checkShow = false;
            }
          });
        }
      },
      deep: true
    },
    marks: {
      handler: function handler(nVal) {
        this.marks.content === undefined ? this.onlyMark = '' : this.onlyMark = this.marks.content;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    // 控制输入分数的最大值-自评
    numberChange: function numberChange(val, maxNum, index, index2) {
      var _this2 = this;
      this.$nextTick(function () {
        if (val < 0) {
          _this2.tableData[index].target[index2].finish_ratio = 0;
        } else if (val > maxNum) {
          _this2.tableData[index].target[index2].finish_ratio = maxNum;
        }
      });
    },
    // 控制输入分数的最大值-上级评价
    scopeChange: function scopeChange(val, maxNum, index, index2) {
      var _this3 = this;
      this.$nextTick(function () {
        if (val < 0) {
          _this3.tableData[index].target[index2].score = 0;
        } else if (val > maxNum) {
          _this3.tableData[index].target[index2].score = maxNum;
        }
      });
      this.totalSum();
    },
    getTableData: function getTableData(val) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              result = {};
              _context.next = 3;
              return userAssessInfo(_this4.id);
            case 3:
              result = _context.sent;
              result.data == undefined ? _this4.tableData = [] : _this4.tableData = result.data.info;
              _this4.assessInfo = result.data ? result.data.assessInfo : {};
              _this4.totalSum();
              // 判断是否为被考核人
              _this4.testAccess = _this4.userInfo.id === _this4.assessInfo.test_uid;
              // 判断是否为考核人
              _this4.checkAccess = _this4.userInfo.id === _this4.assessInfo.check_uid;
              // 判断是否为审核人
              _this4.verifyAccess = _this4.userInfo.id === _this4.assessInfo.verify.id;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addDraft: function addDraft() {
      this.preserve();
    },
    addPreserve: function addPreserve(status) {
      this.onlyShow = status;
      this.is_draft = 0;
      this.preserve(status);
    },
    clickCancel: function clickCancel() {
      this.dialogVisible = false;
      this.from.name = '';
      this.from.ratio = this.dimensionMax;
    },
    handleClose: function handleClose() {
      this.clickCancel();
    },
    // 添加考核维度
    addOk: function addOk() {
      if (this.from.name == '') {
        this.$message.error(this.$t('access.placeholder03'));
      } else if (this.from.ratio == '') {
        this.$message.error(this.$t('access.placeholder04'));
      } else {
        this.tableData.push({
          name: this.from.name,
          ratio: this.assessInfo.types === 0 ? this.from.ratio : 0,
          target: [],
          id: 0
        });
        this.clickCancel();
      }
    },
    isOk: function isOk() {},
    addAssess: function addAssess() {
      this.dialogVisible = true;
    },
    // 编辑分数
    handleScore: function handleScore(index) {
      var _this5 = this;
      if (this.assessInfo.types === 0) {
        return false;
      } else {
        this.tableData[index].ratio = 0;
        this.tableData[index].target.forEach(function (value) {
          _this5.tableData[index].ratio += Number(value.ratio);
        });
      }
    },
    // 删除维度
    deleteTargetList: function deleteTargetList(index, item) {
      this.tableData.splice(index, 1);
      if (item.id !== 0) this.spaceIds.push(item.id);
    },
    // 删除指标
    handleDelete: function handleDelete(index, $index, row) {
      this.tableData[index].target.splice($index, 1);
      if (row.id !== 0) this.targetIds.push(row.id);
      this.handleScore(index);
    },
    // 添加指标
    addTarget: function addTarget(index) {
      var len = this.tableData[index].target.length - 1;
      if (len < 0) {
        this.tableData[index].target = [{
          name: '',
          content: '',
          ratio: '',
          id: 0,
          finish_info: '',
          finish_ratio: 0,
          check_info: '',
          score: 0
        }];
      } else {
        if (this.tableData[index].target[len].name == '') {
          this.$message.error(this.$t('access.placeholder09'));
        } else if (this.tableData[index].target[len].content == '') {
          this.$message.error(this.$t('access.placeholder10'));
        } else if (this.tableData[index].target[len].ratio == '') {
          this.$message.error(this.$t('access.placeholder11'));
        } else {
          this.tableData[index].target.push({
            name: '',
            content: '',
            ratio: '',
            id: 0,
            finish_info: '',
            finish_ratio: 0,
            check_info: '',
            score: 0
          });
        }
      }
    },
    // 选择指标
    selectTarget: function selectTarget(index) {
      this.index = index;
      this.$refs.selectTarget.openDialog();
    },
    dialogChangeDada: function dialogChangeDada(data) {
      var _this6 = this;
      data.forEach(function (res) {
        _this6.tableData[_this6.index].target.push({
          name: res.name,
          content: res.content,
          ratio: '',
          id: 0,
          finish_info: '',
          finish_ratio: 0,
          check_info: '',
          score: 0
        });
      });
    },
    // 保存绩效考核
    preserve: function preserve(status) {
      var sum2 = 0;
      this.tableData.map(function (item) {
        sum2 += Number(item.ratio);
      });
      var res = this.judge();
      if (sum2 != this.enterprise.maxScore) {
        this.$message.error("\u7EF4\u5EA6\u5206\u6570".concat(sum2, "\u548C\u603B\u5206\u4E0D\u4E00\u81F4"));
        return false;
      }
      if (res.length <= 0) {
        return false;
      }
      if (this.userInfo.id === this.assessInfo.test_uid) {
        // 自评
        this.type = 0;
        this.mark = this.assessInfo.self_reply;
      } else if (this.userInfo.id === this.assessInfo.check_uid) {
        this.mark = this.assessInfo.reply;

        // 上级评价
        this.type = 1;
      } else {
        // 绩效审核
        this.type = 2;
      }
      var data = {
        types: this.type,
        is_submit: status == 'only' ? 0 : 1,
        is_draft: status == 'only' ? 1 : this.is_draft,
        mark: this.mark,
        // 上级评价 和自评

        hide_mark: this.assessInfo.hide_reply,
        // 上级评价(仅自己可见)
        space: this.spaceIds,
        target: this.targetIds,
        data: res
      };
      this.loading = true;
      if (this.type == 0) {
        this.selfFn(data);
      } else if (this.type == 1) {
        this.superiorFn(data);
      } else if (this.type == 2) {
        this.examineFn(data);
      }
    },
    // 编辑绩效
    editUserAssess: function editUserAssess(data) {
      var _this7 = this;
      userAssessEditApi(this.id, data).then(function (res) {
        _this7.loading = false;
        if (res.status == 200) {
          if (_this7.onlyShow !== 'only') {
            _this7.$emit('saveOk');
          }
        }
        _this7.is_draft = 0;
        _this7.is_temp = 0;
      }).catch(function (error) {
        _this7.loading = false;
      });
    },
    // 上级评价绩效
    evalUserAssess: function evalUserAssess(data) {
      var _this8 = this;
      userSuperiorEvalSaveApi(this.id, data).then(function (res) {
        _this8.loading = false;
        if (res.status == 200) {
          if (_this8.onlyShow !== 'only') {
            _this8.$emit('saveOk');
          }
        }
        _this8.is_draft = 0;
        _this8.is_temp = 0;
      }).catch(function (error) {
        _this8.loading = false;
      });
    },
    // 上级评价保存
    superiorFn: function superiorFn(data) {
      if (this.strType == 'edit') {
        if (this.processIndex >= 3) {
          this.evalUserAssess(data);
        } else {
          this.editUserAssess(data);
        }
      } else {
        this.evalUserAssess(data);
      }
    },
    // 自评
    selfFn: function selfFn(data) {
      var _this9 = this;
      userAssessSelfSaveApi(this.id, data).then(function (res) {
        _this9.loading = false;
        if (res.status == 200) {
          if (_this9.onlyShow !== 'only') {
            _this9.$emit('saveOk');
          }
        }
        _this9.is_draft = 0;
        _this9.is_temp = 0;
      }).catch(function (error) {
        _this9.loading = false;
      });
    },
    // 上上级评价
    examineFn: function examineFn(data) {
      var _this10 = this;
      userExamineEvalSaveApi(this.id, data).then(function (res) {
        _this10.loading = false;
        if (res.status == 200) {
          if (_this10.onlyShow !== 'only') {
            _this10.$emit('saveOk');
          }
        }
        _this10.is_draft = 0;
        _this10.is_temp = 0;
      }).catch(function (error) {
        _this10.loading = false;
      });
    },
    judge: function judge() {
      var res = [];
      if (this.tableData.length <= 0) {
        this.$message.error(this.$t('access.placeholder12'));
      } else if (this.dimensionMax > 0) {
        if (this.assessInfo.types === 1) {
          this.$message.error('分数之和必须为' + this.assessInfo.max || this.max + '分');
        } else {
          this.$message.error(this.$t('access.placeholder13'));
        }
      } else {
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].name == '') {
            this.$message.error('考核维度名称不能为空');
            break;
          }
          if (this.tableData[i].ratio <= 0 && this.is_draft === 0) {
            this.$message.error('考核维度权重不能为零');
            break;
          }
          if (this.tableData[i].target.length <= 0) {
            this.$message.error('考核指标不能空');
            break;
          }
          var target = [];
          for (var j = 0; j < this.tableData[i].target.length; j++) {
            if (this.tableData[i].target[j].name == '') {
              this.$message.error('指标名称不能为空');
              break;
            }
            if (this.tableData[i].target[j].content == '') {
              this.$message.error('指标内容不能为空');
              break;
            }
            if (this.tableData[i].target[j].ratio <= 0 && this.is_draft === 0) {
              this.$message.error('指标权重不能为零');
              break;
            }
            target.push({
              id: this.tableData[i].target[j].id,
              name: this.tableData[i].target[j].name,
              content: this.tableData[i].target[j].content,
              info: this.tableData[i].target[j].info,
              finish_info: this.tableData[i].target[j].finish_info,
              finish_ratio: this.tableData[i].target[j].finish_ratio ? this.tableData[i].target[j].finish_ratio : 0,
              check_info: this.tableData[i].target[j].check_info,
              score: this.tableData[i].target[j].score === undefined ? 0 : this.tableData[i].target[j].score,
              ratio: this.tableData[i].target[j].ratio
            });
          }
          if (target.length <= 0) {
            break;
          }
          res.push({
            id: this.tableData[i].id,
            name: this.tableData[i].name,
            ratio: this.tableData[i].ratio,
            target: target
          });
          if (res[i].target.length !== this.tableData[i].target.length) {
            res = [];
          }
        }
      }
      if (res.length > 0) {
        return res;
      } else {
        return [];
      }
    },
    preserveMark: function preserveMark() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this11.onlyMark === '')) {
                _context2.next = 4;
                break;
              }
              _this11.$message.error('备注不能为空');
              _context2.next = 7;
              break;
            case 4:
              data = {
                mark: _this11.onlyMark
              };
              _context2.next = 7;
              return userAssessMark(_this11.id, data);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 个人评分计算
    finishRatioSum: function finishRatioSum() {
      var _this12 = this;
      var number = 0;
      var itemNumber = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          if (value.target.length > 0) {
            if (_this12.assessInfo.types === 0) {
              value.target.forEach(function (val) {
                itemNumber += Number(value.ratio * val.ratio * (val.finish_ratio === undefined ? 0 : val.finish_ratio) / 10000);
              });
            } else {
              value.target.forEach(function (val) {
                itemNumber += Number(val.finish_ratio === undefined ? 0 : val.finish_ratio);
              });
            }
          } else {
            itemNumber = 0;
          }
        });
      }
      if (this.assessInfo.types === 0) {
        number = Math.floor(Number(this.assessInfo.total) * itemNumber) / 100;
      } else {
        number = itemNumber;
      }
      return number;
    },
    // 当前得分计算
    currentSum: function currentSum(row, index) {
      var number = 0;
      if (row.target.length > 0) {
        if (this.assessInfo.types === 0) {
          row.target.forEach(function (val) {
            number += Number(row.ratio * val.ratio * (val.score === undefined ? 0 : val.score) / 10000);
          });
          number = Math.floor(Number(this.assessInfo.total) * number) / 100;
        } else {
          row.target.forEach(function (val) {
            number += Number(val.score === undefined ? 0 : val.score);
          });
        }
      }
      this.tableData[index].score = number;
      this.totalSum();
      return number;
    },
    // 当前得分计算--我的自评
    currentFinishSum: function currentFinishSum(row) {
      var number = 0;
      if (row.target.length > 0) {
        if (this.assessInfo.types === 0) {
          row.target.forEach(function (val) {
            number += Number(row.ratio * val.ratio * (val.finish_ratio === undefined ? 0 : val.finish_ratio) / 10000);
          });
          number = Math.floor(Number(this.assessInfo.total) * number) / 100;
        } else {
          row.target.forEach(function (val) {
            number += Number(val.finish_ratio === undefined ? 0 : val.finish_ratio);
          });
        }
      }
      return number;
    },
    totalSum: function totalSum() {
      var _this13 = this;
      var number = 0;
      var itemNumber = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          if (value.target.length > 0) {
            if (_this13.assessInfo.types === 0) {
              value.target.forEach(function (val) {
                itemNumber += Number(value.ratio * val.ratio * (val.score === undefined ? 0 : val.score) / 10000);
              });
            } else {
              value.target.forEach(function (val) {
                itemNumber += Number(val.score === undefined ? 0 : val.score);
              });
            }
          } else {
            itemNumber = 0;
          }
        });
      }
      if (this.assessInfo.types === 0) {
        number = Math.floor(Number(this.assessInfo.total) * itemNumber) / 100;
      } else {
        number = itemNumber;
      }
      this.total = number;
    },
    // 绩效审核
    addFinance: function addFinance() {
      this.formBoxConfig = {
        title: this.testAccess ? this.message2 : this.message1,
        width: '500px',
        method: 'POST',
        action: '/assess/appeal/' + this.id
      };
      this.rolesConfig = [{
        type: 'input',
        field: 'content',
        value: '',
        title: this.testAccess ? this.message2 : this.message1,
        className: 'finance-from',
        props: {
          type: 'textarea',
          placeholder: this.testAccess ? this.message4 : '驳回原因'
        },
        col: {
          lg: {
            span: 22
          }
        },
        validate: [{
          required: true,
          message: this.testAccess ? this.message4 : '驳回原因',
          type: 'string',
          trigger: 'change'
        }]
      }, {
        type: 'hidden',
        field: 'types',
        value: this.testAccess ? 0 : 1
      }];
      this.$refs.dialogForm.openBox();
    },
    // 设置模板
    addTemplate: function addTemplate() {
      var res = this.judge();
      if (res.length <= 0) {
        return false;
      }
      this.$refs.setTemplate.openBox();
    },
    // 设置模板成功后监听
    handleTemplate: function handleTemplate(data) {
      var res = this.judge();
      data.data = res;
      data.is_temp = 1;
      data.is_draft = 0;
      data.types = this.assessInfo.types;
      this.preserveTemplate(data);
    },
    // 添加
    preserveTemplate: function preserveTemplate(data) {
      var _this14 = this;
      this.templateLoading = true;
      userAssessTarget(data).then(function (res) {
        _this14.templateLoading = false;
        _this14.setTemplate.success = 1;
        _this14.is_draft = 0;
        _this14.is_temp = 0;
      }).catch(function (error) {
        _this14.templateLoading = false;
        _this14.setTemplate.success = 1;
      });
    }
  }
};